
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 38 37","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#111","stroke-width":"2","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M13.273 5.91V1h11.454v4.91M24.727 23.909H13.273"}}),_c('path',{attrs:{"d":"M6.727 23.91H1V7.544c0-.904.732-1.636 1.636-1.636h32.728c.904 0 1.636.732 1.636 1.636V23.91h-5.727M35.364 28v5.727c0 .904-.733 1.637-1.637 1.637H4.273a1.636 1.636 0 01-1.637-1.637V28M10 5.909v14.727M10 27.182v8.182M28 5.909v14.727M28 27.182v8.182"}}),_c('path',{attrs:{"d":"M6.727 20.636h6.545v6.545H6.727zM24.727 20.636h6.545v6.545h-6.545z"}})])])
          )
        }
      }
    